import { render, staticRenderFns } from "./UpdateMerchantModal.vue?vue&type=template&id=609902de&scoped=true&"
import script from "./UpdateMerchantModal.vue?vue&type=script&lang=js&"
export * from "./UpdateMerchantModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMerchantModal.vue?vue&type=style&index=0&id=609902de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609902de",
  null
  
)

export default component.exports